import type { ReactNode } from "react";
import { twJoin } from "tailwind-merge";

export const tooltipSurfaceClassName =
  "rounded-xl bg-background-brand-secondary px-tooltip-inline py-tooltip-block text-left text-caption whitespace-pre-line text-text-default-inverse shadow-tooltip";

export function TooltipSurface({ children }: { children: ReactNode }): ReactNode {
  return (
    <aside role="tooltip" className={twJoin("relative max-w-tooltip-wide", tooltipSurfaceClassName)}>
      {children}
    </aside>
  );
}
